export default __webpack_public_path__ + "static/media/2728 knife block B top.2abdb209.png";